import { cn } from '@/lib/cn';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  description?: string;
  disabled?: boolean;
}

export function Toggle({ checked, onChange, label, description, disabled = false }: ToggleProps) {
  return (
    <label className={cn('flex items-start gap-3', disabled && 'opacity-60')}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={cn(
          'mt-0.5 inline-flex h-6 w-10 flex-shrink-0 items-center rounded-full p-0.5 transition-colors',
          checked ? 'bg-brand' : 'bg-ink-subtle/40',
          disabled && 'cursor-not-allowed',
        )}
      >
        <span
          className={cn(
            'h-5 w-5 transform rounded-full bg-white shadow transition-transform',
            checked ? 'translate-x-4' : 'translate-x-0',
          )}
        />
      </button>
      {label || description ? (
        <span className="flex flex-col">
          {label ? <span className="text-sm font-medium text-ink">{label}</span> : null}
          {description ? <span className="text-xs text-ink-muted">{description}</span> : null}
        </span>
      ) : null}
    </label>
  );
}
